import ACL_RELATIONSHIPS from "acl-relationships";
import { TableCreateButton } from "components/BaseTableV3/TableCreateButton";
import { useEntityNavigation } from "routes/entity/useEntityNavigation";

const CREATE_ACLS = [
  ACL_RELATIONSHIPS.entity.create,
  ACL_RELATIONSHIPS.user.read,
];

/** The Entities table's create action. */
const NewEntityButton = () => {
  const { openCreate } = useEntityNavigation();

  return (
    <TableCreateButton permissions={CREATE_ACLS} onClick={openCreate}>
      New Entity
    </TableCreateButton>
  );
};

export default NewEntityButton;
